import { useTranslation } from 'next-i18next'
import { useState } from 'react'

import NotificationAnalytics from '~/analytics/notification/notificationAnalytics'
import BellAltIcon from '~/components/Icons/svgs/BellAltIcon'
import { isChestCompleted } from '~/checklist/helper'
import useCurrentUser from '~/hooks/useCurrentUser'
import { useGetChecklist } from '~/hooks/useChecklist'
import { selectIsNotificationListOpen, setIsNotificationListOpen } from '~/gamification/slices/gamification.slice'
import { selectChecklistChestAnimation } from '~/redux/slices/dashboard'
import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import { useGetNotificationQuery, useSetMarkAsOldMutation } from '~/redux/apis/notification-api'

import NotificationDropDown from './NotificationDropDown'

export const NotificationBellButton = (): React.ReactElement => {
  const { t } = useTranslation('generics')
  const [notificationPage, setNotificationPage] = useState(1)
  const user = useCurrentUser()
  const dispatch = useAppDispatch()
  const notifications = useGetNotificationQuery({ pageNo: notificationPage }, { skip: !user })
  const newNotifications = notifications?.data?.meta.newCount
  const [setMarkAsOld] = useSetMarkAsOldMutation()
  const isNotificationListOpen = useAppSelector(selectIsNotificationListOpen)
  const { data: checklist } = useGetChecklist()
  const chestAnimation = useAppSelector(selectChecklistChestAnimation)
  const checklistAvailable = !chestAnimation && checklist && !isChestCompleted(checklist)

  const handleNotificationClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation()
    NotificationAnalytics.logBellClick(newNotifications || 0)
    dispatch(setIsNotificationListOpen(!isNotificationListOpen))
    if (newNotifications) setMarkAsOld()
  }

  return (
    <>
      <button
        aria-label={t('notifications')}
        className="relative flex w-9 h-9 items-center justify-center rounded-2.5 bg-white-dim"
        data-test-id="topbar-notifications"
        onClick={handleNotificationClick}
      >
        <BellAltIcon className="w-5 h-5" pathClassName="text-white" />
        {(Boolean(newNotifications) || checklistAvailable) && (
          <span className="absolute -top-1 left-5 flex w-5 h-5 items-center justify-center rounded-full border-2 border-solid border-purple-bell-badge bg-red-badge text-xs font-bold text-white">
            {newNotifications || ''}
          </span>
        )}
      </button>
      <NotificationDropDown
        notificationPage={notificationPage}
        notifications={notifications.data}
        setNotificationPage={setNotificationPage}
      />
    </>
  )
}
